module.exports = __webpack_public_path__ + "ui-bg_gloss-wave_35_f6a828_500x100.png";


//////////////////
// WEBPACK FOOTER
// ./~/jquery-ui-bundle/images/ui-bg_gloss-wave_35_f6a828_500x100.png
// module id = 112
// module chunks = 0